module.exports = __webpack_public_path__ + "static/Q3Answer1_Pizza_VitaMarijaMurenaite-a8ff66052a7f565edb661478fc8c50e4.jpg";